import { AT_NEW_PERFORMANCE_ALLOWED_VALUE_SET, ICookieDialogNewPerformanceAllowedValueSetAction } from './types';

export const newPerformanceAllowedValueSet = (
    newPerformanceAllowedValue: boolean
): ICookieDialogNewPerformanceAllowedValueSetAction => ({
    type: AT_NEW_PERFORMANCE_ALLOWED_VALUE_SET,
    newPerformanceAllowedValue
});
